import Vue from "vue";
import VueRouter from "vue-router";
import _ from "lodash";
import store from "@/store";
import gamedataPath from "./path.gamedata";
import managerPath from "./path.manager";
import swingPath from "./path.swing";
import tournaPath from "./path.tournament";
import memberPath from "./path.member";
import supportPath from "./path.support";
import coursePath from "./path.course";
import eventPath from "./path.event";
import i18n from "@/i18n";

Vue.use(VueRouter);

let allowNullName = ["Login", "Logout"];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Main",
      component: () => import(/* webpackChunkName: "main" */ "@/views/Main"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "main",
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login"),
      meta: {
        layout: "NoneLayout",
        wrapId: "sub",
        subtitle: "Login",
        step: ["Login"],
      },
    },
    {
      path: "/logout",
      name: "Logout",
      beforeEnter: (to, from, next) => {
        // auth.logout(sessionStorage.getItem('token'), (flag, data) => {
        //   console.log(flag)
        // })
        store.dispatch("logout");
        next("/login");
      },
    },
    {
      path: "/guide",
      name: 'Guide',
      component: () => import( "@/views/Guide"),
      meta: {
        layout: 'DefaultLayout'
      }
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404"),
      meta: {
        layout: "NoneLayout",
      },
    },
  ],
});

router.addRoute(memberPath);
router.addRoute(gamedataPath);
router.addRoute(managerPath);
router.addRoute(swingPath);
router.addRoute(tournaPath);
router.addRoute(supportPath);
router.addRoute(coursePath);
router.addRoute(eventPath);

router.beforeEach(async (to, from, next) => {
  if (
    from.meta &&
    to.meta &&
    from.name &&
    to.meta.sub_menu_num !== from.meta.sub_menu_num
  ) {
    console.log("setSearchData");
    console.log("to", to);
    console.log("from", from);
    store.commit("setSearchData", {});
  }

  if (!to.matched.length) {
    next("/notFound");
  } else {
    if (_.includes(allowNullName, to.name)) {
      if (
        to.name === "Login" &&
        (localStorage.getItem("token") || sessionStorage.getItem("token"))
      ) {
        alert(i18n.t("alert.common.already_logged"));
        next({
          path: "/",
          replace: true,
        });
      }
      next();
    } else if (
      !localStorage.getItem("token") &&
      !sessionStorage.getItem("token")
    ) {
      store.dispatch("logout");
      next({
        path: "/login",
        replace: true,
      });
    } else {
      next();
    }
  }
});

export default router;
